import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import useReveal from '@/hooks/useReveal';

export default function CookiesPage() {
  useReveal();
  return (
    <div className="bg-ink-950 text-white">
      <Navbar />
      <section className="relative min-h-[50vh] flex items-center overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=Ultra%20dark%20cinematic%20abstract%20digital%20cookie%20and%20browser%20icon%20with%20purple%20neon%20glow%20on%20deep%20black%20background%20premium%20technology%20data%20privacy%20visualization%20clean%20minimalist%20composition&width=1800&height=1200&seq=fc-cookies-bg&orientation=landscape"
          alt=""
          className="absolute inset-0 w-full h-full object-cover opacity-40"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-ink-950/80 via-ink-950/70 to-ink-950" />
        <div className="relative mx-auto max-w-7xl px-6 pt-32 pb-16 w-full">
          <h1 className="font-display text-4xl md:text-6xl font-bold text-gradient">Cookie Policy</h1>
          <p className="mt-4 text-white/60">Last updated: August 2026</p>
        </div>
      </section>
      <section className="relative py-20 px-6">
        <div className="mx-auto max-w-3xl space-y-10">
          {[{
            title: '1. What Are Cookies',
            text: 'Cookies are small text files stored on your device when you visit a website. They help websites function properly, remember your preferences, and provide analytics data to improve user experience.',
          }, {
            title: '2. How We Use Cookies',
            text: 'We use cookies to: remember your preferences, understand how visitors interact with our website, analyze traffic patterns, and improve our services. We do not use cookies to collect personally identifiable information without your consent.',
          }, {
            title: '3. Types of Cookies',
            text: 'Essential cookies are required for basic site functionality. Analytical cookies help us understand visitor behavior. Functional cookies remember your preferences. Marketing cookies may be used for advertising purposes with your consent.',
          }, {
            title: '4. Managing Cookies',
            text: 'You can manage or disable cookies through your browser settings. Please note that disabling certain cookies may affect the functionality of our website.',
          }, {
            title: '5. Third-Party Cookies',
            text: 'We may use third-party analytics services (such as Google Analytics) that set their own cookies. These services have their own cookie policies.',
          }, {
            title: '6. Updates',
            text: 'We may update this Cookie Policy periodically. Changes will be posted on this page with an updated effective date.',
          }].map((s) => (
            <div key={s.title} className="reveal">
              <h2 className="font-display text-xl font-bold text-white mb-3">{s.title}</h2>
              <p className="text-white/60 leading-relaxed">{s.text}</p>
            </div>
          ))}
        </div>
      </section>
      <Footer />
    </div>
  );
}